import script from "./swiperDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./swiperDialog.vue?vue&type=script&setup=true&lang=js"

import "./swiperDialog.vue?vue&type=style&index=0&id=e37685e0&lang=css"

const __exports__ = script;

export default __exports__